import cn from "classnames";
import { useMemo } from "react";
import styles from "./styles.module.scss";

interface Props {
  count: number;
  kind: "line" | "rectangle" | "picture";
  isStatic?: boolean;
  randomSize?: boolean;
  align?: "right" | "left";
}

const Skeleton = (props: Props) => {
  // TODO: Implement dynamic mode
  const isRandom = props.randomSize ?? true;
  const kind = props.kind;
  const align = props.align ?? "left";
  const count = props.count;

  // Generate the random line widths once per (count, kind, isRandom) instead of
  // on every render — otherwise unrelated re-renders (e.g. typing in the search
  // box, which updates Documents state) reshuffle the bars and they visibly jump.
  const widths = useMemo(
    () =>
      Array.from({ length: count }, () =>
        isRandom && kind === "line" ? `${70 + Math.random() * 30}%` : undefined
      ),
    [count, kind, isRandom]
  );

  return (
    <>
      {widths.map((width, i) => (
        <div
          key={i}
          className={cn({
            [styles.skeleton]: true,
            [styles.lineSkeleton]: kind === "line",
            [styles.rectSkeleton]: kind === "rectangle",
            [styles.pictureSkeleton]: kind === "picture",
            [styles.skeletonRight]: align === "right",
          })}
          style={width ? { width } : undefined}
        />
      ))}
    </>
  );
};

export default Skeleton;
